// extracted by mini-css-extract-plugin
export var body = "card--host-module--body--212bc";
export var content = "card--host-module--content--a00b8";
export var logo = "card--host-module--logo--d44ca";